import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const INTEGRATION_NAME_LINKS = {
  [IntegrationEnum.HOSTFULLY]: 'http://www.hostfully.com/',
  [IntegrationEnum.STRIPE]: 'https://stripe.com/',
  [IntegrationEnum.PAYPAL]: 'https://paypal.com/',
  [IntegrationEnum.VACATIONRENTPAYMENT]: 'http://vacationrentpayment.com/',
  [IntegrationEnum.VANTORY]: 'https://app.vantory.ai/connect/hostfully',
  [IntegrationEnum.PRICELABS]: 'https://pricelabs.co/',
  [IntegrationEnum.WHEELHOUSE]: 'https://www.usewheelhouse.com/',
  [IntegrationEnum.BEYONDPRICING]: 'http://www.beyondpricing.com/',
  [IntegrationEnum.PERFECT_PRICE]: 'https://www.perfectprice.com/',
  [IntegrationEnum.RENTED]: 'https://www.rented.com/',
  [IntegrationEnum.DPGO]: 'https://www.dpgo.com/',
  [IntegrationEnum.NIGHTPRICER]: 'https://nightpricer.com/home',
  [IntegrationEnum.TURBOSUITE]: 'http://www.turbosuite.com/',
  [IntegrationEnum.QUIBBLE]: 'https://quibblerm.com/',
  [IntegrationEnum.STAYTRACK]: 'http://www.stay-track.com',
  [IntegrationEnum.SMARTPRICING]: 'https://www.smartpricing.it/en',
  [IntegrationEnum.VIRTUALKEY]: 'https://www.getlynx.co/',
  [IntegrationEnum.REMOTELOCK]: 'http://www.remotelock.com/',
  [IntegrationEnum.POINTCENTRAL]: 'https://www.pointcentral.com/',
  [IntegrationEnum.IGLOOHOME_CO]: 'http://www.igloohome.co/',
  [IntegrationEnum.OPERTO]: 'http://www.operto.com/',
  [IntegrationEnum.MINUT]: 'https://www.minut.com/',
  [IntegrationEnum.OK2CHARGE]: 'https://www.ok2charge.com//',
  [IntegrationEnum.WYND]: 'https://hellowynd.com/',
  [IntegrationEnum.TURNOVERBNB]:
    'https://app.turnoverbnb.com/partner/hostfully',
  [IntegrationEnum.TURNSTAY]: 'https://dashboard.turnstay.com/register',
  [IntegrationEnum.BREEZEWAY]:
    'https://www.breezeway.io/?utm_medium=partnership&utm_source=hostfully&utm_campaign=hostfully&utm_content=active',
  [IntegrationEnum.PROPERLY]: 'http://www.getproperly.com/',
  [IntegrationEnum.VRSCHEDULER]: 'https://www.vrscheduler.com/',
  [IntegrationEnum.EZ_INSPECTIONS]: 'http://ezcare.io/',
  [IntegrationEnum.SOJO]: 'https://www.getsojo.com/',
  [IntegrationEnum.CLEANSTER_DOT_COM]: 'http://Cleanster.com',
  [IntegrationEnum.RESORTCLEANING]: 'https://www.resortcleaning.com/',
  [IntegrationEnum.CLYN]: 'https://clyn.app/',
  [IntegrationEnum.FIDO]: 'http://www.getfido.com/',
  [IntegrationEnum.QUICKBOOKS]: 'https://quickbooks.intuit.com',
  [IntegrationEnum.VRPLATFORM]: 'https://www.vrplatform.app/',
  [IntegrationEnum.CLEARING]: 'https://getclearingbank.com/',
  [IntegrationEnum.CTRLBNB]: 'https://ctrlbnb.io/',
  [IntegrationEnum.HOSTFI]: 'https://gethostfi.com/',
  [IntegrationEnum.TRUVI]:
    'https://truvi.com/platform/integrations/?source=hostfully',
  [IntegrationEnum.SAFELY]: 'https://safely.ai/',
  [IntegrationEnum.INSURAGUEST]: 'https://www.insuraguest.com/',
  [IntegrationEnum.AUTOHOST]: 'https://www.autohost.ai/',
  [IntegrationEnum.CSA]: 'https://www.csatravelprotection.com/',
  [IntegrationEnum.CHEKIN]: 'https://chekin.com/',
  [IntegrationEnum.RELAXDAMAGEWAIVER]: 'https://www.relaxwaiver.com/',
  [IntegrationEnum.CHECKIN_SCAN]: 'https://www.checkinscan.com/',
  [IntegrationEnum.HOSTKIT]: 'https://hostkit.pt/hostfully',
  [IntegrationEnum.HOSTREADY]: 'https://www.hostready.ai/',
  [IntegrationEnum.FARENIO]: 'https://farenio.com/',
  [IntegrationEnum.CENDRA]: 'https://app.cendra.ai/',
  [IntegrationEnum.POMELLO]: 'https://app.pomello.app/connect/hostfully',
  [IntegrationEnum.STRLY]: 'https://strly.com/',
  [IntegrationEnum.AUTHENTICATE]:
    'https://authenticate.com/?utm_source=hostfully&utm_medium=marketplace_page',
  [IntegrationEnum.TINT]: 'https://www.tint.ai/hostfully',
  [IntegrationEnum.HELLOSIGN]: 'https://sign.dropbox.com/',
  [IntegrationEnum.HELLOGUESTSCREEN]: 'http://www.helloguestscreen.com/',
  [IntegrationEnum.NOISEAWARE]: 'https://noiseaware.io/',
  [IntegrationEnum.HUDSON_CREATIVE_STUDIO]: 'https://homerunner.io/hostfully/',
  [IntegrationEnum.BOOSTLY]: 'https://boostly.co.uk/directbookingwebsite',
  [IntegrationEnum.ICOASTALNET]: 'https://icoastalnet.com/',
  [IntegrationEnum.DTRAVEL]:
    'https://www.dtravel.com/operators/dtravel-direct?utm_campaign=marketplace&utm_medium=partnership&utm_source=hostfully',
  [IntegrationEnum.GETHOSTAI]:
    'https://gethostai.com/products/hostfront?medium=cpc&source=google&campaignid=21419043315&adgroupid=163713022523&device=c&keyword=hostai&matchtype=e&creative=704285151531&extensionid=&targetid=kwd-853198570781&loc_interest_ms=&loc_physical_ms=9020396&network=g&gclid=Cj0KCQjwq_G1BhCSARIsACc7NxqZgMz_H5NKEA9t1T6FyHS10u_JZxeQS7v88ld1o-L1hmtDQXfJgTUaAn9dEALw_wcB&placement=&target=&adposition=&gad_source=1',
  [IntegrationEnum.CRAFTED_STAYS]:
    'https://craftedstays.co/partners/hostfully/',
  [IntegrationEnum.MAGICSUPPORT]:
    'https://app.magicbnb.io/integrations/pms/hostfully/connect',
  [IntegrationEnum.MAILCHIMP]: 'http://mailchimp.com/',
  [IntegrationEnum.AUTORANK]: 'https://www.autorank.com/',
  [IntegrationEnum.SMARTPINEAPPLE]: 'https://www.smartpineapple.ai/',
  [IntegrationEnum.RENTAMIRA]:
    'https://www.rentamira.com/?utm_source=hostfully&utm_medium=integration&utm_campaign=hostfully_integration',
  [IntegrationEnum.LASOH]: 'https://www.lasoh.io/',
  [IntegrationEnum.THEHOSTCO]:
    'https://thehost.co/?utm_campaign=hostfully%20landing%20page&utm_source=hostfully&utm_medium=website',
  [IntegrationEnum.MATTERPORT]: 'https://matterport.com/',
  [IntegrationEnum.TRUPLACE]: 'http://truplace.com/',
  [IntegrationEnum.KEY_DATA]: 'https://www.keydatadashboard.com/',
  [IntegrationEnum.COHOST]: 'https://www.cohost.com/analytics',
  [IntegrationEnum.MOVINGLAKE]: 'http://www.movinglake.com/',
  [IntegrationEnum.SUMMEROS]:
    'https://www.summeros.com/?utm_source=partners&utm_medium=website&utm_campaign=hostfully&utm_content=integrations',
  [IntegrationEnum.NANNYBAG]: 'https://www.nannybag.com/',
  [IntegrationEnum.LUGGAGEHERO]: 'https://luggagehero.com/',
  [IntegrationEnum.REVYOOS]: 'https://revyoos.com/',
  [IntegrationEnum.REVA]: 'https://www.joinreva.com/',
  [IntegrationEnum.CLOVERLY]: 'https://cloverly.com/',
  [IntegrationEnum.TINYPNG]: 'https://tinypng.com/',
  [IntegrationEnum.OUTSWITCH]: 'http://www.outswitch.com/',
  [IntegrationEnum.PAYFULLY]: 'https://www.payfully.co/',
  [IntegrationEnum.ZAPIER]: 'https://www.zapier.com/',
  [IntegrationEnum.AKIA]: 'https://www.akia.com/',
  [IntegrationEnum.TEXTREQUEST]: 'https://www.textrequest.com/',
  [IntegrationEnum.CHARGEAUTOMATION]: 'https://chargeautomation.com/',
  [IntegrationEnum.ENSO]: 'https://ensoconnect.com/',
  [IntegrationEnum.CONCIERGEBOT]: 'https://www.concierge.bot/',
  [IntegrationEnum.CONDUIT]: 'https://www.conduit.app/',
  [IntegrationEnum.YADA]: 'https://yada.ai/',
  [IntegrationEnum.GUEST_GURU]: 'https://guestguru.ai/',
  [IntegrationEnum.PRIMEHOST]: 'https://primehost.ai/',
  [IntegrationEnum.HOSTBUDDY_AI]: 'https://hostbuddy.ai',
  [IntegrationEnum.GUEST_LABS]: 'https://guestlabs.com/',
  [IntegrationEnum.APARTA]: 'https://aparta.tech/',
  [IntegrationEnum.LINKBASE]: 'https://linkbase.ca',
  [IntegrationEnum.AIPEX]: 'https://www.aipextech.com',
  [IntegrationEnum.SUITEOP]: 'https://suiteop.com/',
  [IntegrationEnum.NOSHABLE]: 'https://www.shopnoshable.com/',
  [IntegrationEnum.EXTENTEAM]: 'https://www.extenteam.com/solutions/tailwind',
  [IntegrationEnum.RIGHT2RENT]: 'https://r2rcollaborative.org/',
  [IntegrationEnum.BELLHOPT]: 'https://host.bellhopt.com/signup',
  [IntegrationEnum.BESTY_AI]: 'https://getbesty.ai/',
  [IntegrationEnum.TECHTAPE]:
    'https://www.gettechtape.com/schedule-call-hostfully',
  [IntegrationEnum.VIKEY]: 'https://vikey.it/en/home-page/',
  [IntegrationEnum.STAYFI]: 'https://stayfi.com/',
  [IntegrationEnum.PETSCREENING]:
    'https://www.petscreening.com/industries/vacation-rentals',
  [IntegrationEnum.LOCALBIRD]: 'https://localbird.io',
  [IntegrationEnum.CLEVERFI]: 'https://cleverfi.com/',
  [IntegrationEnum.BOUNCE]:
    'https://partner.bounce.com/signup/affiliate?referral_code=HOSTFULLY61236845080',
  [IntegrationEnum.KNOKX]: 'https://knokx.com/',
  [IntegrationEnum.DOINN]:
    'https://doinn.co/book-demo/?utm_campaign=25_partnerships&utm_source=hostfully&utm_medium=referral',
  [IntegrationEnum.OTAPLUS]: 'https://infobizsolutions.com/',
  [IntegrationEnum.ONSEASON]: 'https://app.onseason.ai',
  [IntegrationEnum.FLATAWAY]: 'https://app.onseason.ai',
  [IntegrationEnum.TOPKEY]: 'https://topkey.io/',
  [IntegrationEnum.INTELLIHOST]:
    'https://clients.intellihost.co/connections?connect=pms',
  [IntegrationEnum.GUESTGENIE]:
    'https://guestgenie.com/?utm_source=marketplace&utm_medium=web&utm_campaign=hostfully_marketplace&utm_id=Hostfully',
  [IntegrationEnum.SAFEGUEST]: 'https://safeguest.ai/hostfully',
  [IntegrationEnum.NEWBYTE]: 'https://newbyte.net.br/en',
  [IntegrationEnum.FURNISHED_FINDER]: 'https://www.furnishedfinder.com/',
  [IntegrationEnum.STRDESK]: 'https://www.strdesk.com/',
  [IntegrationEnum.WELCOMESCREEN]: 'https://welcomescreen.com/',
};

export const SECONDARY_INTEGRATION_LINKS = {
  [IntegrationEnum.DPGO]: 'https://www.dpgo.com/markets/',
  [IntegrationEnum.INSURAGUEST]:
    'https://hospitality.insuraguest.com/hostfully-signup',
  [IntegrationEnum.KEY_DATA]:
    'https://www.hostfully.com/partner-promotions/key-data-exclusive/',
};
